/*
 * -----------------------------------------------------------------------
 *  <copyright file="study-crfs.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';

import { StudyAssessmentFragment, StudyCrfFragment } from './fragments';

export const GET_STUDY_CRFS = gql`
    query studyCrfs($studyId: ObjectId!, $timestamp: DateTime) {
        crfs(studyId: $studyId, timestamp: $timestamp) {
            ...StudyCrfFields
        }
    }
    ${StudyCrfFragment}
`;

export const SAVE_STUDY_CRF = gql`
    mutation upsertCrf($studyId: ObjectId!, $crf: StudyCrfInput!, $reason: String) {
        upsertCrf(studyId: $studyId, crf: $crf, reason: $reason) {
            ...StudyCrfFields
        }
    }
    ${StudyCrfFragment}
`;

export const GET_STUDY_CRF_ASSESSMENTS = gql`
    query studyCrfAssessments($studyId: ObjectId!, $timestamp: DateTime) {
        crfAssessments(studyId: $studyId, timestamp: $timestamp) {
            ...StudyAssessmentFields
        }
    }
    ${StudyAssessmentFragment}
`;

export const SAVE_STUDY_CRF_ASSESSMENT = gql`
    mutation saveStudyCrfAssessment($studyId: ObjectId!, $assessment: StudyAssessmentInput!, $reason: String) {
        upsertCrfAssessment(studyId: $studyId, assessment: $assessment, reason: $reason) {
            ...StudyAssessmentFields
        }
    }
    ${StudyAssessmentFragment}
`;

export const SAVE_CRFS = gql`
    mutation upsertCrfs($crfs: [StudyCrfInput!]!, $studyId: ObjectId!) {
        upsertCrfs(crfs: $crfs, studyId: $studyId) {
            ...StudyCrfFields
        }
    }
    ${StudyCrfFragment}
`;

